import plugin from './confirm-plugin'

export default plugin
